// Shared low-poly parts for buildings — the construction language every staged
// building reuses: a stone foundation slab, scaffolding poles while the walls
// go up, and a classical pediment. Ported from age-of-mcp's
// src/client/models/building-parts.ts (pure geometry, Part type from the
// library). World tile units; y = 0 is the floor.
import * as THREE from "three";
import type { Part } from "../types";

const STONE = "#5a5a5a";
const SCAFFOLD = "#6b4a26";

/** A flat stone foundation slab, `w` tiles square and `t` tiles thick. */
export function foundationSlab(w: number, t = 0.14): Part {
  return {
    geometry: new THREE.BoxGeometry(w, t, w),
    color: STONE,
    position: [0, t / 2, 0],
  };
}

/** Four thin scaffolding poles at the corners of a `w`-wide build, `h` tall. */
export function scaffold(w: number, h: number): Part[] {
  const o = w / 2;
  const out: Part[] = [];
  for (const [x, z] of [[-o, -o], [o, -o], [-o, o], [o, o]]) {
    out.push({
      geometry: new THREE.CylinderGeometry(0.025, 0.025, h, 4),
      color: SCAFFOLD,
      position: [x!, h / 2, z!],
    });
  }
  return out;
}

/**
 * A flat triangular PEDIMENT (classical gable tympanum) standing in the X-Y
 * plane and facing +Z: base `width` wide resting on the eave line `eaveY`,
 * rising to an apex `height` above it, `depth` thick, centred at `cx` / `z`.
 */
export function pediment(
  width: number, height: number, depth: number,
  cx: number, eaveY: number, z: number, color: THREE.ColorRepresentation,
): Part {
  return {
    geometry: new THREE.CylinderGeometry(1, 1, 1, 3, 1, false, Math.PI / 2),
    color,
    position: [cx, eaveY + height / 3, z],
    rotation: [-Math.PI / 2, 0, 0],
    scale: [width / Math.sqrt(3), depth, height / 1.5],
  };
}
